import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const GitHubCallback = () => {
  const navigate = useNavigate();
  const { githubLogin } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleGitHubCallback = async () => {
      // Get the code from URL
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      
      if (code) {
        try {
          // Exchange code for token
          await githubLogin(code);
          navigate('/profile');
        } catch (err) {
          console.error('GitHub login error:', err);
          setError('Failed to authenticate with GitHub. Please try again.');
          setTimeout(() => {
            navigate('/login');
          }, 3000);
        }
      } else {
        setError('No authorization code received from GitHub');
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      }
    };

    handleGitHubCallback();
  }, [githubLogin, navigate]);

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <h1>GitHub Authentication</h1>
            {!error ? (
              <div className="loading-container">
                <div className="loading-spinner"></div>
                <p>Authenticating with GitHub...</p>
              </div>
            ) : (
              <div className="auth-error">
                <i className="fas fa-exclamation-circle"></i>
                <span>{error}</span>
                <p>Redirecting to login page...</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GitHubCallback;
